export default function unauthorizedResponse() {
  return {
    status: 'Unauthorized',
    statusText: 'You are not authorized to view this page.',
  };
}
